// extracted by mini-css-extract-plugin
export default {"root":"g94up","animator":"Jc0jy","notification-link":"_2LP2R","notificationLink":"_2LP2R"};